export class ModoPagamento {
  public modoPag?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
